import { render } from "./SiteNameSelector.vue?vue&type=template&id=61e12da0"
import script from "./SiteNameSelector.vue?vue&type=script&lang=js"
export * from "./SiteNameSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__